import React from 'react';

/**
 * MultiSelectPills — toggleable chip group. Each option click toggles its
 * membership in `value` (string[]). Used for classFormat, focusModes, etc.
 *
 * Props:
 *   options  — string[] (or { value, label }[])
 *   value    — string[] currently active
 *   onChange — (newArray) => void
 *   testId   — data-testid base for each pill
 */
const MultiSelectPills = ({ options = [], value = [], onChange, testId = 'pill' }) => {
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((opt) => {
        const v = typeof opt === 'string' ? opt : opt.value;
        const label = typeof opt === 'string' ? opt : opt.label;
        const active = value.includes(v);
        return (
          <button
            key={v}
            type="button"
            onClick={() => toggle(v)}
            data-testid={`${testId}-${v.toLowerCase().replace(/\s+/g, '-').replace(/[/]/g, '')}`}
            aria-pressed={active}
            className={`px-3 py-1.5 text-xs rounded-md border transition-colors ${
              active
                ? 'bg-enf-accent border-enf-accent-fg text-enf-text-primary'
                : 'bg-enf-surface-mid border-enf-surface-border text-enf-text-secondary hover:text-enf-text-primary'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default MultiSelectPills;
